/**
 * chat v1 bootstrap — run once the app knows it is signed in (from Authed).
 *
 * Silently obtains a chat v1 token if it can (a fresh dev seed, or a refresh-token renewal),
 * registers this device (required before ws-tickets), and opens the socket. It does NOT
 * redirect to Cognito on its own — an interactive login would yank a signed-in user off
 * their page for a feature they may not be using — so when no token is obtainable it simply
 * does nothing, and the chat UI starts the redirect lazily when the user opens chat.
 */
import { ensureChatv1Token, chatv1SignedOut } from './auth'
import { registerDevice } from './transport'
import { connectChatv1, disconnectChatv1 } from './ws'

let running = false

export async function bootstrapChatv1(): Promise<void> {
  if (running) return
  const token = await ensureChatv1Token()
  if (!token) return // interactive login needed — deferred to the chat UI
  running = true
  try {
    await registerDevice()
  } catch {
    // A transient failure here shouldn't strand us: the socket's ticket path re-registers
    // pressure via reconnect, and the next bootstrap attempt retries this.
    running = false
    return
  }
  connectChatv1()
}

export function teardownChatv1(): void {
  running = false
  chatv1SignedOut()
  disconnectChatv1()
}
